var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tags && _vm.tags.length
    ? _c(
        "nav",
        {
          directives: [
            {
              name: "swiper",
              rawName: "v-swiper:tagsCarousel",
              value: _vm.swiperOptions,
              expression: "swiperOptions",
              arg: "tagsCarousel"
            }
          ],
          staticClass: "tag-nav"
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper tag-nav__list" },
            _vm._l(_vm.tags, function(item) {
              return _c(
                "div",
                { staticClass: "swiper-slide tag-nav__item" },
                [
                  _c(
                    "btn",
                    {
                      class: [
                        "btn",
                        "tag-nav__link",
                        item.tag === _vm.tag ? "btn--primary" : "btn--outline"
                      ],
                      attrs: {
                        tag: "link",
                        link: _vm.$route.path + _vm.setPath(item.tag)
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\n\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            }),
            0
          ),
          _c("btn", {
            staticClass: "tag-nav__prev btn--outline",
            attrs: { tag: "control" }
          }),
          _c("btn", {
            staticClass: "tag-nav__next btn--outline",
            attrs: { tag: "control" }
          }),
          _c("div", { staticClass: "tag-nav__blur" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19de33c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19de33c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/TagNav.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-19de33c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/TagNav.vue
// module chunks = 0